export default "__VITE_ASSET__D8wb9I2T__"